<template>
	<v-layout>
		<Dialog :dialog="dialog" :dialogWidth="dialogWidth">
			<template v-slot:title>
				<v-layout>
					<v-flex> Create Project </v-flex>
				</v-layout>
			</template>
			<template v-slot:body>
				<v-container class="py-0">
					<v-form
						ref="quickForm"
						v-model="formValid"
						lazy-validation
						v-on:submit.stop.prevent="createProject"
					>
						<v-row class="py-0">
							<v-col cols="12" md="2" class="py-0">
								<label for="site-number" class="btx-label mt-4 required">Title</label>
							</v-col>
							<v-col cols="12" md="10" class="py-0">
								<TextInput
									hide-details
									:disabled="pageLoading"
									:loading="pageLoading"
									id="title"
									placeholder="Title"
									v-model="project.title"
									:rules="[vrules.required(project.title, 'Title')]"
									:class="{
										required: !project.title,
									}"
								></TextInput>
							</v-col>
							<v-col cols="12" md="2" class="py-0">
								<label for="customer" class="btx-label mt-4 required">Customer</label>
							</v-col>
							<v-col cols="12" md="10" class="py-0">
								<SelectCustomerSupplier
									v-model="project.customer"
									:items="customerList"
									type="customer"
									:rules="[vrules.required(project.customer.id, 'Customer')]"
									placeholder="Customer"
									:class="{
										required: !project.customer.id,
									}"
									input-id="customer-id"
									:key="`customer-id${uniqueId}`"
								></SelectCustomerSupplier>
							</v-col>
							<v-col cols="12" sm="6" md="2" class="py-0">
								<label for="start_date" class="btx-label mt-4 required">Start Date</label>
							</v-col>
							<v-col cols="12" sm="6" md="4" class="py-0">
								<DatePicker
									hide-details
									:disabled="pageLoading"
									:loading="pageLoading"
									:rules="[vrules.required(project.start_date, 'Start Date')]"
									:class="{
										required: !project.start_date,
									}"
									id="start-date"
									v-model="project.start_date"
								>
								</DatePicker>
							</v-col>
							<v-col cols="12" sm="6" md="2" class="py-0 text-lg-right">
								<label for="till_date" class="btx-label mt-4 required">End Date </label>
							</v-col>
							<v-col cols="12" sm="6" md="4" class="py-0">
								<DatePicker
									:minDate="project.start_date"
									hide-details
									:disabled="pageLoading"
									:loading="pageLoading"
									:rules="[vrules.required(project.end_date, 'End Date')]"
									:class="{
										required: !project.end_date,
									}"
									id="till_date"
									placeholder="End Date"
									v-model="project.end_date"
								>
								</DatePicker>
							</v-col>
						</v-row>
					</v-form>
				</v-container>
			</template>
			<template v-slot:action>
				<v-btn
					tile
					depressed
					:disabled="pageLoading"
					class="mx-2 custom-grey-border custom-bold-button"
					v-on:click="$emit('close-dialog', true)"
				>
					Close
				</v-btn>
				<v-btn
					tile
					depressed
					:disabled="pageLoading"
					:loading="pageLoading"
					class="mx-2 custom-grey-border custom-bold-button white--text"
					color="blue darken-4 white--text"
					v-on:click="createProject"
				>
					Save
				</v-btn>
			</template>
		</Dialog>
	</v-layout>
</template>
<script>
import { mapGetters } from "vuex";
import { SET_ERROR, SET_MESSAGE } from "@/core/services/store/common.module";
import Dialog from "@/view/components/Dialog";
import { CreateProject } from "@/core/lib/project.lib";
import TextInput from "@/view/components/TextInput";
import { toSafeInteger } from "lodash";
import { SET_LOCAL_DB } from "@/core/services/store/config.module";
import SelectCustomerSupplier from "@/view/components/SelectCustomerSupplier";
import DatePicker from "@/view/components/DatePicker";
import { deleteData } from "@/core/services/local.service";

export default {
	props: {
		dialog: {
			type: Boolean,
			required: true,
			default: false,
		},
		selectedCustomer: {
			type: Object,
			default: () => {
				return new Object();
			},
		},
		category: {
			type: Array,
			default: () => {
				return new Array();
			},
		},
	},
	/*   watch:{
		customerList: {
			deep: true,
			handler() {
				  this.project.customer = this.selectedCustomer;
			},
		},
	}, */

	data: () => {
		return {
			uniqueId: Number(new Date()),
			formValid: true,
			pageLoading: false,
			customerList: [],
			project: {
				id: null,
				uuid: null,
				contact: null,
				title: null,
				// property: null,
				attachment: [],
				customer: {
					id: null,
					contact_person_id: null,
					property_id: null,
				},
				remark: null,
				start_date: null,
				end_date: null,
				members: [],
				description: null,
				value: null,
				customer_purchase_order: null,
				quotations: [],
				references_no: null,
				amount: null,
				team_members: [],
				budget: null,
				specification: null,
				bankers_guarantee: {
					bank: null,
					amount: null,
					remark: null,
					attachment: [],
				},
				insurance_bank: {
					insurance_bank: null,
					amount: null,
					remark: null,
					attachment: null,
				},
			},
		};
	},
	methods: {
		async createProject() {
			const _this = this;

			const formErrors = _this.validateForm(_this.$refs.quickForm);
			if (formErrors.length) {
				_this.$store.commit(SET_ERROR, _this.errors.concat(formErrors));
				return false;
			}

			if (!_this.$refs.quickForm.validate()) {
				return false;
			}

			const formData = {
				contact: this.project.customer.id,
				contact_person: this.project.customer.contact_person_id,
				property: this.project.customer.property_id,
				start_date: this.project.start_date,
				end_date: this.project.end_date,
				customer_purchase_order: this.project.customer_purchase_order,
				name: this.project.title,
				quotations: this.project.quotations,
				reference_no: this.project.references_no,
				members: this.project.team_members,
				specifications: this.project.specification,
				description: this.project.description,
				project_value: this.project.value,
				project_cost: this.project.budget,
				files: [],
			};
			try {
				_this.pageLoading = true;
				await CreateProject(formData);
				_this.$store.commit(SET_MESSAGE, [
					{ model: true, message: "Success ! Project has been created." },
				]);
				// clearing local storage data
				deleteData("create_project");
				this.$emit("success", true);
				this.$emit("close-dialog", true);
			} catch (error) {
				_this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
			} finally {
				_this.pageLoading = false;
			}
		},
	},
	components: {
		Dialog,
		TextInput,
		DatePicker,
		SelectCustomerSupplier,
	},
	mounted() {
		this.$store.dispatch(SET_LOCAL_DB).then(() => {
			this.customerList = this.localDB("customers", []);
		});
	},
	computed: {
		...mapGetters(["errors", "localDB"]),
		dialogWidth() {
			/* if (document.body.clientWidth > 992) {
				return 800;
			} */
			return toSafeInteger((document.body.clientWidth / 100) * 60);
		},
	},
};
</script>
